<template>
  <div id="home">


    <!--        <script class="u-script" type="appilcation/javascript" src="src/assets/js/jquery.js" defer=""></script>-->
    <!--    <script class="u-script" type="application/javascript" src="src/assets/js/jquery.js" defer=""></script>-->
    <link rel="stylesheet" href="src/assets/css/Copy-of-Home2.css" media="screen">


    <section class="u-clearfix u-gradient u-valign-top u-section-1" id="sec-9aa1">
      <div
          class="u-carousel u-expanded-width u-gallery u-gallery-slider u-layout-carousel u-lightbox u-no-transition u-show-text-on-hover u-gallery-1"
          data-interval="5000" data-u-ride="carousel" id="carousel-12eb">
        <ol class="u-absolute-hcenter u-carousel-indicators u-carousel-indicators-1">
          <li data-u-target="" data-u-slide-to="0" class="u-active u-grey-70 u-shape-circle"
              style="width: 10px; height: 10px;"></li>
          <li data-u-target="" data-u-slide-to="1" class="u-grey-70 u-shape-circle"
              style="width: 10px; height: 10px;"></li>
        </ol>
        <div class="u-carousel-inner u-gallery-inner" role="listbox">
          <div class="u-active u-carousel-item u-effect-fade u-gallery-item u-carousel-item-1"
               data-href="#">
            <div class="u-back-slide" data-image-width="960" data-image-height="640">
              <img class="u-back-image u-expanded" src="/src/assets/images/iphone-410311_960_720.jpg">
            </div>
            <div class="u-align-center u-over-slide u-shading u-valign-middle u-over-slide-1">
              <h3 class="u-gallery-heading">Demo project only</h3>
              <p class="u-gallery-text">this is a demo project</p>
            </div>
          </div>
          <div class="u-carousel-item u-effect-fade u-gallery-item u-carousel-item-2">
            <div class="u-back-slide" data-image-width="960" data-image-height="639">
              <img class="u-back-image u-expanded" src="/src/assets/images/iphone-410324_960_720.jpg">
            </div>
            <div class="u-align-center u-over-slide u-shading u-valign-middle u-over-slide-2">
              <h3 class="u-gallery-heading">Demo project only</h3>
              <p class="u-gallery-text">Sample Text</p>
            </div>
          </div>
        </div>

        <a class="u-absolute-vcenter u-carousel-control u-carousel-control-prev u-grey-70 u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-carousel-control-1"
           href="#carousel-12eb" role="button" data-u-slide="prev">
          <span aria-hidden="true">
            <svg viewBox="0 0 451.847 451.847"><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path></svg>
          </span>
          <span class="sr-only">
            <svg viewBox="0 0 451.847 451.847"><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path></svg>
          </span>
        </a>
        <a class="u-absolute-vcenter u-carousel-control u-carousel-control-next u-grey-70 u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-carousel-control-2"
           href="#carousel-12eb" role="button" data-u-slide="next">
          <span aria-hidden="true">
            <svg viewBox="0 0 451.846 451.847"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path></svg>
          </span>
          <span class="sr-only">
            <svg viewBox="0 0 451.846 451.847"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path></svg>
          </span>
        </a>
      </div>
      <h3 class="u-align-center u-text u-text-default u-text-1">Disover our new stock of cellphones and brands !<br>
        <br>
      </h3>
    </section>
    <section class="u-clearfix u-section-2" id="sec-3d2a">
      <div class="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <h2 class="u-align-center-xs u-text u-text-default u-text-1">New Coming</h2>
      </div>
    </section>
    <section class="u-align-center u-clearfix u-section-3" id="sec-b6b9">
      <div class="u-clearfix u-sheet u-sheet-1">

        <div>
          <NewComing></NewComing>
        </div>
        <h2 data-v-fae5bece="" class="u-text u-text-default u-text-1">On Sale</h2>
        <div class="u-align-center u-clearfix u-custom-html u-custom-html-1">


          <div class="container" style="overflow:hidden;margin-top: 5%; background-color: white; ">
            <Carousel></Carousel>
          </div>

        </div>


      </div>
    </section>
    <section class="u-clearfix u-section-4" id="sec-067c">
      <div class="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <h2 class="u-text u-text-default u-text-1">Categories</h2>
      </div>
    </section>

    <section class="u-align-left u-clearfix u-section-5" id="sec-48a5">
      <div class="u-clearfix u-sheet u-valign-top-xs u-sheet-1">
        <div class="u-clearfix u-expanded-width-xs u-gutter-16 u-layout-wrap u-layout-wrap-1">
          <div class="u-layout">
            <div class="u-layout-col">
              <div class="u-size-30">
                <div class="u-layout-row">
                  <div
                      class="u-container-style u-effect-fade u-hover-box u-hover-feature u-layout-cell u-size-30 u-layout-cell-1"
                      data-href="/Products?type=Samsung"
                      :style="{'background-image': 'url(' + (`${$store.state.products[5].image}`) + ')'}">
                    <div class="u-back-slide u-border-2 u-border-grey-75 u-container-layout u-container-layout-1"
                         data-image-width="510" data-image-height="340" data-href="/products" style="/* From https://css.glass */
background: rgba(255, 255, 255, 0.2);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(5px);
-webkit-backdrop-filter: blur(5px);
border: 1px solid rgba(255, 255, 255, 0.3);">
                      <h1 class="u-hover-feature u-text u-text-default u-text-1" data-animation-name="lightSpeedIn"
                          data-animation-duration="1000" data-animation-direction=""
                          style="will-change: transform, opacity; animation-duration: 1000ms;"><img
                          src="https://cdn-icons-png.flaticon.com/512/882/882747.png" style="height:149px"></h1>
                    </div>
                    <div
                        class="u-black u-container-layout u-opacity u-opacity-25 u-over-slide u-container-layout-2"></div>
                  </div>

                  <!--       box 1 end-->
                  <div
                      class="u-container-style u-effect-fade u-hover-box u-hover-feature u-layout-cell u-size-30 u-layout-cell-1"
                      data-href="/Products?type=Iphone"
                      :style="{'background-image': 'url(' + (`${$store.state.products[2].image}`) + ')'}">
                    <div class="u-back-slide u-border-2 u-border-grey-75 u-container-layout u-container-layout-1"
                         data-image-width="510" data-image-height="340" data-href="/products" style="/* From https://css.glass */
background: rgba(255, 255, 255, 0.2);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(5px);
-webkit-backdrop-filter: blur(5px);
border: 1px solid rgba(255, 255, 255, 0.3);">
                      <h1 class="u-hover-feature u-text u-text-default u-text-1" data-animation-name="lightSpeedIn"
                          data-animation-duration="1000" data-animation-direction=""
                          style="will-change: transform, opacity; animation-duration: 1000ms;"><img
                          src="https://cdn-icons-png.flaticon.com/512/882/882704.png" style="height:149px"></h1>
                    </div>
                    <div
                        class="u-black u-container-layout u-opacity u-opacity-25 u-over-slide u-container-layout-2"></div>
                  </div>


                </div>
              </div>
              <div class="u-size-30">
                <div class="u-layout-row">
                  <!--start box 3-->
                  <div
                      class="u-container-style u-effect-fade u-hover-box u-hover-feature u-layout-cell u-size-30 u-layout-cell-1"
                      data-href="/Products?type=otherBrands"
                      :style="{'background-image': 'url(' + (`${$store.state.products[4].image}`) + ')'}">
                    <div class="u-back-slide u-border-2 u-border-grey-75 u-container-layout u-container-layout-1"
                         data-image-width="510" data-image-height="340" data-href="/products" style="/* From https://css.glass */
background: rgba(255, 255, 255, 0.2);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(5px);
-webkit-backdrop-filter: blur(5px);
border: 1px solid rgba(255, 255, 255, 0.3);">
                      <h1 class="u-hover-feature u-text u-text-default u-text-1" data-animation-name="lightSpeedIn"
                          data-animation-duration="1000" data-animation-direction=""
                          style="will-change: transform, opacity; animation-duration: 1000ms;"><img
                          src="src/assets/icons/output-onlinepngtools.png" style="height:149px"></h1>
                    </div>
                    <div
                        class="u-black u-container-layout u-opacity u-opacity-25 u-over-slide u-container-layout-2"></div>
                  </div>
                  <!--end box 3-->

                  <!--start box 4-->
                  <div
                      class="u-container-style u-effect-fade u-hover-box u-hover-feature u-layout-cell u-size-30 u-layout-cell-1"
                      data-href="/Products?type=miscellanous"
                      :style="{'background-image': 'url(' + (`${$store.state.products[7].image}`) + ')'}">
                    <div class="u-back-slide u-border-2 u-border-grey-75 u-container-layout u-container-layout-1"
                         data-image-width="510" data-image-height="340" data-href="/products" style="/* From https://css.glass */
background: rgba(255, 255, 255, 0.2);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(5px);
-webkit-backdrop-filter: blur(5px);
border: 1px solid rgba(255, 255, 255, 0.3);">
                      <h1 class="u-hover-feature u-text u-text-default u-text-1" data-animation-name="lightSpeedIn"
                          data-animation-duration="1000" data-animation-direction=""
                          style="will-change: transform, opacity; animation-duration: 1000ms;"><img src=""
                                                                                                    style="height:149px"
                                                                                                    hidden>Miscellanous
                      </h1>
                    </div>
                    <div
                        class="u-black u-container-layout u-opacity u-opacity-25 u-over-slide u-container-layout-2"></div>
                  </div>
                  <!--                  emd box 4-->

                </div>
              </div>
            </div> <!--end boxes-->
          </div>
        </div>
      </div>
    </section>

    <div>
      <section class="u-clearfix u-section-7" id="carousel_33d1">
        <div class="u-clearfix u-sheet u-sheet-1">
          <div
              class="u-clearfix u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-layout-wrap u-layout-wrap-1">
            <div class="u-gutter-0 u-layout">
              <div class="u-layout-row">
                <div class="u-align-left u-container-style u-layout-cell u-right-cell u-size-26 u-layout-cell-1">
                  <div class="u-container-layout u-container-layout-1">
                    <h1 class="u-text u-text-default u-text-7">why shop with us</h1>
                    <a data-v-fae5bece="" href=""
                       class="u-active-none u-btn u-btn-rectangle u-button-style u-hover-none u-none u-radius-0 u-text-palette-1-dark-1 u-btn-1"><span
                        data-v-fae5bece="" class="u-icon"><svg data-v-fae5bece="" viewBox="0 0 405.333 405.333"
                                                               x="0px" y="0px" class="u-svg-content"
                                                               style="width: 1em; height: 1em;"></svg><img
                        data-v-fae5bece=""></span>
                      <svg data-v-fae5bece="" preserveAspectRatio="xMidYMin slice" viewBox="0 0 512 512"
                           class="u-svg-link" style="width:10%">
                        <use data-v-fae5bece="" xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#svg-41ce"></use>
                      </svg>
                    </a>
                    <h2 class="u-text u-text-palette-1-dark-1 u-text-4">Free Delivery</h2>
                    <p class="u-text u-text-3">&nbsp;Within 3 – 5&nbsp; working days for orders over R500. Excludes
                      furniture.<br>
                      <br>
                    </p>
                    <a
                        class="u-active-none u-btn u-btn-rectangle u-button-style u-hover-none u-none u-radius-0 u-text-palette-1-dark-1 u-btn-1"><span
                        class="u-icon"><svg class="u-svg-content" viewBox="0 0 405.333 405.333" x="0px" y="0px"
                                            style="width: 1em; height: 1em;"><path
                        d="M373.333,266.88c-25.003,0-49.493-3.904-72.704-11.563c-11.328-3.904-24.192-0.896-31.637,6.699l-46.016,34.752    c-52.8-28.181-86.592-61.952-114.389-114.368l33.813-44.928c8.512-8.512,11.563-20.971,7.915-32.64    C142.592,81.472,138.667,56.96,138.667,32c0-17.643-14.357-32-32-32H32C14.357,0,0,14.357,0,32    c0,205.845,167.488,373.333,373.333,373.333c17.643,0,32-14.357,32-32V298.88C405.333,281.237,390.976,266.88,373.333,266.88z"></path></svg><img></span>&nbsp;+1
                      (234) 567-8910
                    </a>
                    <h2 class="u-text u-text-palette-1-dark-1 u-text-4">24/7 Support</h2>
                    <br><br><br>
                    <h2 class="u-text u-text-palette-1-dark-1 u-text-4">Diverse payment's options<span
                        style="float: right"><i class="fa fa-cc-visa" style="color:navy;margin:1px"></i></span></h2>
                    <p class="u-text u-text-3">&nbsp;Choose Between: Pay by Visa, Cash on delivery, or Pickup.<br>
                      <!--                        <br>-->
                    </p>
                  </div>
                </div>


                <!--                  <div class="u-container-style u-layout-cell u-left-cell u-size-34 u-layout-cell-2">-->
                <div class="u-container-layout u-container-layout-2">
                  <!--                                    <img src="/src/assets/images/high-angle-app-learning-new-language-phone_23-2148293463.jpg" alt=""-->
                  <!--                                         class="u-align-center u-image u-image-default u-image-1">-->
                  <img :src="`${$store.state.products[0].image}`" alt=""
                       class="u-align-center u-image u-image-default u-image-1">
                </div>
                <!--                  </div>-->
              </div>
            </div>
          </div>
          <span>
<svg class="u-svg-content"
     viewBox="0 0 512 512"
     id="svg-41ce"><g><path
    d="m496.761 352.176c7.89-.429 14.161-6.952 14.161-14.958 0-43.164-34.648-76.976-78.879-76.976h-14.617l-17.866-84.802c17.24-7.49 29.332-24.692 29.332-44.675 0-26.842-21.811-48.68-48.621-48.68h-69.115c-8.274 0-14.982 6.716-14.982 15v18.68h-36.828c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15h36.828v18.68c0 8.284 6.708 15 14.982 15h6.652c-12.404 14.669-19.907 33.618-19.907 54.299v85.359c0 .438-.355.793-.792.793h-60.52c-.349 0-.661-.233-.76-.568l-16.315-55.202c13.149-3.517 22.865-15.542 22.865-29.801 0-33.857-27.511-61.401-61.326-61.401h-134.987c-25.4-.001-46.066 20.69-46.066 46.122 0 23.25 17.273 42.526 39.644 45.666-23.732 21.254-38.697 52.13-38.697 86.444v46.699c0 8.284 6.708 15 14.982 15h12.963c6.978 34.84 37.766 61.17 74.587 61.17s67.609-26.33 74.587-61.17h183.27c6.978 34.84 37.766 61.17 74.587 61.17 41.948 0 76.076-34.17 76.076-76.17.001-17.124-5.675-32.943-15.238-45.679zm-18.256-29.958h-33.727c-2.907-.339-5.858-.533-8.854-.533-5.37 0-10.608.568-15.666 1.632v-33.075h11.786c21.942 0 40.083 13.207 46.461 31.976zm-152.368-210.134h54.134c10.288 0 18.658 8.38 18.658 18.68s-8.37 18.68-18.658 18.68h-54.134zm-89.547 237.811h60.52c16.959 0 30.755-13.813 30.755-30.793v-85.359c0-25.782 18.086-47.416 42.223-52.849l20.207 95.91v60.143c-14.662 11.039-25.221 27.252-28.958 45.907h-148.95c-6.997-53.818-51.439-94.083-106.909-94.083-24.735 0-46.941 8.08-64.461 21.97 14.472-27.092 43.004-45.571 75.776-45.571h71.786l18.522 62.67c3.836 12.986 15.963 22.055 29.489 22.055zm-204.462 32.959c2.618-15.958 9.435-30.353 19.86-41.507 13.607-14.559 32.603-22.577 53.488-22.577 38.642 0 69.859 27.156 76.561 64.083h-149.909zm13.938-147.684c-8.879 0-16.103-7.233-16.103-16.124s7.224-16.124 16.103-16.124h134.987c17.294 0 31.363 14.086 31.363 31.401-.128.617-1.116 1.025-2.955.845-12.464 0-8.901 0-11.497 0-17.901.002-151.811.002-151.898.002zm57.413 208.854c-20.183 0-37.367-13.055-43.601-31.17h87.202c-6.234 18.115-23.418 31.17-43.601 31.17zm332.445 0c-25.427 0-46.113-20.712-46.113-46.17s20.687-46.169 46.113-46.169c25.427 0 46.113 20.711 46.113 46.169s-20.687 46.17-46.113 46.17z"></path><ellipse
    cx="435.924" cy="397.855" rx="15.081" ry="15.099"></ellipse><path
    d="m65.382 67.976h135.526c8.274 0 14.982-6.716 14.982-15s-6.708-15-14.982-15h-135.526c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15z"></path>
</g></svg></span>


        </div>

      </section>
    </div>
    <footer data-v-abb9de30="" data-v-fae5bece="" id="sec-b4e8"
            class="u-align-center u-clearfix u-footer u-grey-80 u-footer">
      <div data-v-abb9de30="" data-v-fae5bece=""
           class="u-align-left-xs u-clearfix u-sheet u-valign-bottom u-sheet-1"></div>
      <section data-v-abb9de30="" data-v-fae5bece="" class="u-backlink u-clearfix u-grey-80"><a data-v-abb9de30=""
                                                                                                data-v-fae5bece=""
                                                                                                href="#"
                                                                                                target="_blank"
                                                                                                class="u-link"><span
          data-v-abb9de30="" data-v-fae5bece="">Website Templates</span></a>
        <p data-v-abb9de30="" data-v-fae5bece="" class="u-text"><span data-v-abb9de30=""
                                                                      data-v-fae5bece="">created with</span></p><a
            data-v-abb9de30="" data-v-fae5bece="" href="" target="_blank" class="u-link"><span data-v-abb9de30=""
                                                                                               data-v-fae5bece="">Website Builder Software</span></a>.

      </section>
    </footer>


  </div>
</template>

<script>
import mapState from "vuex/dist/vuex.mjs";
import $ from "jquery";

import Carousel from "../components/Carousel";
import NewComing from "../components/ProductsComponents/NewComing";
import {UrlResolver} from "../main";


// $(".slider").not('.slick-initialized').slick=null; // very important so you wont get error in the console
export default {
  name: "Home",
  // mUrlResolver:this.UrlResolver.resolve('public/src/assets/css/Copy-of-Home2.css',''),
  mUrlResolver: 'src/assets/css/Copy-of-Home2.css',
  components: {NewComing, Carousel},
  // props:['products'],
  computed: {
    // ...mapState(['products']),
    computedProperty: function () {

      // alert(JSON.stringify(this.mapState['products']))
      // return this.mapState['products'][0].image

    }
  },
}
</script>

<style scoped>
div#home > .u-align-left.u-section-5 {
  max-height: 800px;
}


@media (max-width: 768px) {
  u-text u-text-default u-text-1 {
    margin-top: 198px;
  }
}

@media (max-width: 360px) {
  u-text u-text-default u-text-1 {
    margin-top: 4px;
  }
}

@media (max-width: 360px), screen and(max-height: 812px) {
  u-text u-text-default u-text-1 {
    margin-top: 86px;
  }
}


[class*="u-border-"], .u-link[class*="u-border-"] {
  border-style: unset;
}


.container { /*for mobile*/
  height: 50%;
  margin-top: unset !important;
}


div#home > .u-align-center.u-section-3 {
  /*position: relative;*/
  max-height: 750px;
}

.u-section-7 {
  /*max-height: unset !important;*/
}

html, body {
  overflow-x: hidden;
}

html {
  max-height: unset !important;
}


</style>